import React from 'react';
import { AppBar, Tab, Tabs, Typography, Box, Grid, Container } from '@material-ui/core';
import useStyles from './styles';
import community_img from '../../../assets/tab section/community.png';
import company_img from '../../../assets/tab section/company.png';
import project_support_img from '../../../assets/tab section/project_support.png';
import community_icon from '../../../assets/logo/community_icon.png';
import company_icon from '../../../assets/logo/company_icon.png';
import project_support_icon from '../../../assets/logo/project_support_icon.png';
// import { classicNameResolver } from 'typescript';
import useCommonStyles from '../../CommonStyle/commonStyle';
import useMedia from "use-media";




interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  // const classes = useStyles();
  //   const commonClasses = useCommonStyles();

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography component={'span'}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: any) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}


export default function SliderTab() {
  const classes = useStyles();
    // const commonClasses = useCommonStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };
  const isLarger850 = useMedia({ minWidth: "850px" });

  return (
    <div className={classes.root}>
      <AppBar position="static" color="default" className={classes.tabPanel}>
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="inherit"
          variant="fullWidth"
          aria-label="full width tabs example"
          className={classes.tabs}
          TabIndicatorProps={{
            style: {
              height: "6px",
            }
          }}
        >
          <Tab icon={<img src={community_icon} className={classes.sliderTabIcons}/>} label="コミュニティに参加" {...a11yProps(0)} className={classes.tab} />
          <Tab icon={<img src={company_icon} className={classes.sliderTabIcons}/>} label="企業との出会い" {...a11yProps(1)} className={classes.tab} />
          <Tab icon={<img src={project_support_icon} className={classes.sliderTabIcons}/>} label="プロジェクトのサポート" {...a11yProps(2)} className={classes.tab} />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0} >
        <Container className={isLarger850 ? classes.tabGrid : classes.tabGridSmall}>
          <Container className={isLarger850 ? classes.innnerContentBig : classes.innnerContentSmall}>
            <img className={classes.image} src={community_img} alt="コミュニティー" />
          </Container>
          <Container className={isLarger850 ? classes.innnerContentBig : classes.innnerContentSmall}>
            <Typography component={'span'} className={classes.contentText + ' ' + classes.title}>
              コミュニティを通して同世代と共に、<br />自分や社会問題について知ろう。<br /><br />
            </Typography>
            <Typography component={'span'} className={classes.contentText}>
              全国各地の自治体や学校などからFlareのコミュニティに多様な同世代が参加しています。 <br /><br />企業や自治体などと連携したイベントや交流会を通して、社会問題について探究したり、同世代の仲間や企業と出会えたり、解決に向けたプロジェクトのアイデアをより良くしていく事ができます。
            </Typography>
          </Container>
        </Container>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Container className={isLarger850 ? classes.tabGrid : classes.tabGridSmall}>
          <Container className={isLarger850 ? classes.innnerContentBig : classes.innnerContentSmall}>
            <img className={classes.image} src={company_img} alt="企業との出会い" />
          </Container>
          <Container className={isLarger850 ? classes.innnerContentBig : classes.innnerContentSmall}>
            <Typography component={'span'} className={classes.contentText + ' ' + classes.title}>
              自分のプロジェクトを投稿して、<br />共創する企業と繋がろう。<br /><br />
            </Typography>
            <Typography component={'span'} className={classes.contentText}>
              コミュニティで学んだ事や仲間との出会いを活かして、自分のプロジェクトを投稿してみよう。<br /><br />プロジェクトを投稿して企業と繋がろう。Flareでは企業と未成年とのコミュニケーションを安全に行えるシステムが整備されています。<br /><br />企業から共創に向けたメッセージが届いたら、共創スタート！
            </Typography>
          </Container>
        </Container>
      </TabPanel>
      <TabPanel value={value} index={2}>
        <Container className={isLarger850 ? classes.tabGrid : classes.tabGridSmall}>
          <Container className={isLarger850 ? classes.innnerContentBig : classes.innnerContentSmall}>
            <img className={classes.image} src={project_support_img} alt="プロジェクト　サポート" />
          </Container>
          <Container className={isLarger850 ? classes.innnerContentBig : classes.innnerContentSmall}>
            <Typography component={'span'} className={classes.contentText + ' ' + classes.title}>
              さあ、共創をはじめよう。<br /><br />
            </Typography>
            <Typography component={'span'} className={classes.contentText}>
              あなたのプロジェクトと企業との共創をより良くするために、参加しているプロジェクトの共創事例やノウハウの提供、法律面のサポートや大学生のメンターの派遣、活動資金、発信のサポート、アドバイサリーによる専門的な視点からのフィードバックなど、共創プロジェクトの実現を多様な側面からサポートします。 <br /><br />Flareでの共創で、みんなで社会問題を解決しよう。
            </Typography>
          </Container>
        </Container>
      </TabPanel>
    </div>
  );
}
